export default __webpack_public_path__ + "static/media/Edit_white.51d30952.svg";